export const resetPasswordActions = {
  resetPasswordLoading: "RESET_PASSWORD_LOADING",
  resetPasswordReady: "RESET_PASSWORD_READY"
};
